import { styled } from "@linaria/react";
import React, { Suspense } from "react";
import useScrollbarWidth from "./useScrollbarWidth";
import useHeaderHeight from "../Header/useHeaderHeight";
import { color, zIndex } from "..";
const PRIMARY_HEADER_HEIGHT_CSS_VARIABLE = "--primary-header-height";

const Wrapper = styled.div`
  @media screen {
    background-color: ${color.titanium50};
  }
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  @media screen {
    position: sticky;
    top: 0;
    z-index: ${zIndex.fixedHeader};
  }
  @media print {
    display: none;
  }
`;

const MainLayout = ({
  children,
  header,
}: {
  children: React.ReactNode;
  header: React.ReactNode;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  useHeaderHeight(headerRef, PRIMARY_HEADER_HEIGHT_CSS_VARIABLE);
  useScrollbarWidth();

  return (
    <Wrapper>
      <Header ref={headerRef}>
        <Suspense>{header}</Suspense>
      </Header>
      {children}
    </Wrapper>
  );
};

export default React.memo(MainLayout);
